import { render, staticRenderFns } from "./editorTextNew.vue?vue&type=template&id=040dacca&scoped=true&"
import script from "./editorTextNew.vue?vue&type=script&lang=js&"
export * from "./editorTextNew.vue?vue&type=script&lang=js&"
import style0 from "./editorTextNew.vue?vue&type=style&index=0&id=040dacca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040dacca",
  null
  
)

export default component.exports